import { render } from "./IncomeProtectionProviderSelection.vue?vue&type=template&id=5ff7e54b&scoped=true"
import script from "./IncomeProtectionProviderSelection.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionProviderSelection.vue?vue&type=script&lang=js"

import "./IncomeProtectionProviderSelection.vue?vue&type=style&index=0&id=5ff7e54b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff7e54b"]])

export default __exports__